var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFinanceStep04 = function SvgIconFinanceStep04(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 120,
    width: 120,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1039-156H401v789h-1440z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.11 16.76v4.069H33.804v3.211H29.62v87.792h68.984v-3.96h2.682v-8.043l.063.108 2.09-3.618.956-1.658 1.133-1.96V39.745h-4.242V20.829H77.978V16.76z",
    fill: "#cfdde9"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#051a2d",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.217 38.819h45.886v-4.154H35.217zm24.538 48.809h21.348v-4.154H59.755z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.808 15.904v83.831h64.8m-64.8-83.831v-3.21h23.308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.808 15.904h-4.183v87.793h68.982v-3.962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.217 49.178h45.886v-4.154H35.217zm0 10.434h45.886V55.46H35.217zm12.899-43.708v-3.211m0 0V8.625h20.867v4.068m0 0v3.211m-20.867 0v.857h20.867v-.857m19.191 55.671V79.3m7.226 7.226-.957 1.657-2.09 3.619-.063-.109m0 0-2.026-3.51-2.09-3.619V79.3m4.116-47.691V12.693H68.983m23.307 79v8.043h-2.682m2.682-68.127h4.243l-.001 48.324m-8.358-8.359V31.61h4.116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.532 79.932v4.632L95.4 86.526"
  })))));
};
export default SvgIconFinanceStep04;